// extracted by mini-css-extract-plugin
module.exports = {"button":"_YPCH2ukL","detailsButton":"_-cAsiz56","actions":"_aiaIGxuN"};